export default __webpack_public_path__ + "static/char-v-57-0a15c7221e85c25a22dc091a2591cba2.png";